module.exports = __webpack_public_path__ + "img/icons-thumb.61ba62a4.png";